import { render, staticRenderFns } from "./JiraConfigureForm.vue?vue&type=template&id=d35e148a"
import script from "./JiraConfigureForm.vue?vue&type=script&lang=js"
export * from "./JiraConfigureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports